<div class="p-2 mt-auto border-t border-surface-800 relative">
  <ul
    class="list-none p-2 m-0 hidden origin-bottom animate-duration-150 border border-surface-700 bg-surface-900 absolute bottom-full left-0 right-0 rounded-lg mb-1">
    <li>
      <a class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-400 hover:bg-surface-800 border border-transparent hover:border-surface-700 transition-colors duration-150 hover:text-surface-0"
         routerLink="/app/profile"
         (click)="navigateToProfile()">
        <i class="pi pi-user text-base! leading-none!"></i>
        <span class="font-medium text-base leading-tight">Profile</span>
      </a>
    </li>
    @if (billingState.billing()) {
    <li>
      <a class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-400 hover:bg-surface-800 border border-transparent hover:border-surface-700 transition-colors duration-150 hover:text-surface-0"
         (click)="navigateToBilling()">
        <i class="pi pi-credit-card text-base! leading-none!"></i>
        <span class="font-medium text-base leading-tight">Billing</span>
      </a>
    </li>
    }
    @if (isTenantAdmin) {
    <li>
      <a class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-400 hover:bg-surface-800 border border-transparent hover:border-surface-700 transition-colors duration-150 hover:text-surface-0"
         (click)="navigateToTenantInformation()">
        <i class="pi pi-cog text-base! leading-none!"></i>
        <span class="font-medium text-base leading-tight">Settings</span>
      </a>
    </li>
    }
    <li>
      <a class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-400 hover:bg-surface-800 border border-transparent hover:border-surface-700 transition-colors duration-150 hover:text-surface-0"
         (click)="onSignOut()"
      >
        <i class="pi pi-sign-out text-base! leading-none!"></i>
        <span class="font-medium text-base leading-tight">Sign Out</span>
      </a>
    </li>
  </ul>

  <a class="flex items-center cursor-pointer p-2 gap-2 text-surface-400 hover:text-surface-0"
     pStyleClass="@prev"
     enterFromClass="hidden"
     enterActiveClass="animate-scalein"
     leaveToClass="hidden"
     leaveActiveClass="animate-fadeout">
    @if (avatarUrl$ | async; as avatarUrl) {
      <img [src]="avatarUrl" class="w-8 h-8 rounded-full object-cover" alt="User avatar" />
    } @else {
      <div class="w-8 h-8 rounded-full bg-surface-700 flex items-center justify-center text-surface-0 text-xs font-bold">
        {{ initials$ | async }}
      </div>
    }
    <span class="text-sm leading-tight">{{ (name$ | async) || username }}</span>
    <i class="pi pi-angle-up text-base! leading-none! text-surface-400 ml-auto"></i>
  </a>
</div>
